function announcementResizeListener() {
  let headerAnnouncementOutput = document.querySelector(".announcement-bar-section");

  function initializeheaderResize() {
    let getAnnouncementHeight = headerAnnouncementOutput.offsetHeight;
    document.documentElement.style.setProperty('--header-anouncement-height', `${getAnnouncementHeight}px`);
  }

  // Initialize on page load
  initializeheaderResize();

  // Reinitialize on window resize
  window.addEventListener("resize", initializeheaderResize);
}

announcementResizeListener();

function scrollToTOp() {
  // Select the scroll-to-top button
  let scrollToTopButton = document.querySelector('#scroll-top');

  // Add scroll event to track scroll position
  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      scrollToTopButton.classList.add('active');
    } else {
      scrollToTopButton.classList.remove('active');
    }
  });

  // Add click event to scroll back to top
  scrollToTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling effect
    });
  });
}

scrollToTOp();

/*
 * Swiper JS Configurations
 * This script initializes and configures various Swiper sliders
 * for different sections of the pool goods.
 */

// Initialize Collection Slider
var swiperCollection = document.querySelector(".swiper-collection");

if (swiperCollection) {
  var slidesCollectionPerView = parseInt(swiperCollection.getAttribute("data-slider-items")) || 6;

  var collectionSwiper = new Swiper(".swiper-collection", {
    slidesPerView: slidesCollectionPerView,
    spaceBetween: 16,
    pagination: {
      el: ".collection--nav .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".collection--nav .swiper-button-next",
      prevEl: ".collection--nav .swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        spaceBetween: 12,
      },
      1024: {
        slidesPerView: 4,
      },
      1280: {
        slidesPerView: slidesCollectionPerView - 1,
      }
    }
  });
}

var swiperProduct = document.querySelector(".swiper-product");
if (swiperProduct) {
  var slidesProductPerView = parseInt(swiperProduct.getAttribute("data-slider-items")) || 6;
  var hasBorderClass = swiperProduct.classList.contains('card-product-with-border');

  // Initialize Featured Product Slider
  var productSwiper = new Swiper(".swiper-product", {
    slidesPerView: slidesProductPerView,
    spaceBetween: hasBorderClass ? 0 : 8,
    pagination: {
      el: ".product--nav .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".product--nav .swiper-button-next",
      prevEl: ".product--nav .swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2.1,
        spaceBetween: hasBorderClass ? 0 : 4,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: hasBorderClass ? 0 : 8,
      },
      1280: {
        slidesPerView: slidesProductPerView - 1,
        spaceBetween: hasBorderClass ? 0 : 8,
      },
      1350: {
        slidesPerView: slidesProductPerView - 1,
        spaceBetween: hasBorderClass ? 0 : 8,
      }
    }
  });
}

var swiperProductSale = document.querySelector(".swiper-product-sale");
if (swiperProductSale) {
  var slidesProductPerView = parseInt(swiperProductSale.getAttribute("data-slider-items")) || 6;
  var hasBorderClass = swiperProductSale.classList.contains('card-product-with-border');

  // Initialize Featured Product Slider
  var productSwiper = new Swiper(".swiper-product-sale", {
    slidesPerView: slidesProductPerView,
    spaceBetween: hasBorderClass ? 0 : 8,
    pagination: {
      el: ".product--nav-sale .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".product--nav-sale .swiper-button-next",
      prevEl: ".product--nav-sale .swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2.1,
        spaceBetween: hasBorderClass ? 0 : 4,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: hasBorderClass ? 0 : 8,
      },
      1280: {
        slidesPerView: slidesProductPerView - 1,
        spaceBetween: hasBorderClass ? 0 : 8,
      },
      1350: {
        slidesPerView: slidesProductPerView - 1,
        spaceBetween: hasBorderClass ? 0 : 8,
      }
    }
  });
}

var crosssellSwipers = document.querySelectorAll(".crosssell-swiper");

crosssellSwipers.forEach(function(crosssellSwiper) {
  var crosssellProduct = crosssellSwiper.querySelector(".crosssell-swiper-product");

  if (crosssellProduct && crosssellProduct.querySelectorAll("li").length > 0) {
    crosssellProduct.parentElement.classList.add("active");
  }

  if (crosssellProduct) {
    var slidesProductPerView = parseInt(crosssellProduct.getAttribute("data-slider-items")) || 6;
    var hasBorderClass = crosssellProduct.classList.contains('card-product-with-border');

    // Initialize Crosssell Product Slider
    new Swiper(crosssellProduct, {
      slidesPerView: 2,
      spaceBetween: hasBorderClass ? 0 : 8,
      pagination: {
        el: crosssellSwiper.querySelector(".product--nav .swiper-pagination"),
        type: "fraction",
      },
      navigation: {
        nextEl: crosssellSwiper.querySelector(".product--nav .swiper-button-next"),
        prevEl: crosssellSwiper.querySelector(".product--nav .swiper-button-prev"),
      }
    });
  }
});

// Initialize Blog Post Slider
var blogSwiper = new Swiper(".swiper-blog-post", {
  slidesPerView: 2,
  spaceBetween: 16,
  pagination: {
    el: ".blog-post--nav .swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".blog-post--nav .swiper-button-next",
    prevEl: ".blog-post--nav .swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1.1
    }
  }
});

var blogOneSwiper = new Swiper(".swiper-blog-one-post", {
  slidesPerView: 1,
  pagination: {
    el: ".blog-one-post--nav .swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".blog-one-post--nav .swiper-button-next",
    prevEl: ".blog-one-post--nav .swiper-button-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    640: {
      slidesPerView: 1.1,
      spaceBetween: 16
    }
  }
});

// Initialize variables at the top level for scoping
let faqSections;
let faqItems;
let faqHeadings;

document.addEventListener('DOMContentLoaded', () => {
  faqSections = document.getElementsByClassName('section-collection-faq');
  faqItems = document.getElementsByClassName('accordion-item');
  faqHeadings = document.getElementsByClassName('accordion-item-heading');

  function toggleItem() {
    const itemClass = this.parentNode.className;
    for (let i = 0; i < faqItems.length; i++) {
      faqItems[i].className = 'accordion-item close';
    }
    if (itemClass === 'accordion-item close') {
      this.parentNode.className = 'accordion-item open';
    }
  }

  for (let i = 0; i < faqHeadings.length; i++) {
    faqHeadings[i].addEventListener('click', toggleItem, false);
  }

  if (faqItems && faqItems.length <= 0 && faqSections && faqSections.length) {
    document.querySelector('.section-collection-faq').remove();
  }

  for (let i = 0; i < faqItems.length; i++) {
    if (i === 0) {
      faqItems[i].classList.add('open');
      faqItems[i].classList.remove('close');
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // PDP read more link scroll
  document.querySelectorAll('.read-more').forEach((button) => {
    button.addEventListener('click', () => {
      const targetElement = document.querySelector('.collapsible-content');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // PDP move policy container on mobile
  const policyContainer = document.querySelector(".policy-container");
  const productInfoContainer = document.querySelector(".product__info-container");
  const mediaGallery = document.querySelector("media-gallery");
  const mobileBreakpoint = 749;
  function movePolicyContainer() {
    if (window.innerWidth <= mobileBreakpoint) {
      if (policyContainer && productInfoContainer && !productInfoContainer.contains(policyContainer)) {
        productInfoContainer.appendChild(policyContainer);
      }
    } else {
      if (policyContainer && mediaGallery && !mediaGallery.contains(policyContainer)) {
        mediaGallery.appendChild(policyContainer);
      }
    }
  }
  movePolicyContainer();
  window.addEventListener("resize", movePolicyContainer);
});
